<template>
  <div class="warp">
    <el-form inline size="mini">
      <el-form-item label="Source of Data:">
        <select-box
          width="240"
          :options="originData"
          :value.sync="extraData.dataSourceCode"
          placeholder="Please select source of data"
        />
      </el-form-item>
      <el-form-item label="Status:">
        <select-box
          width="240"
          :options="statusOptions"
          :value.sync="extraData.status"
        />
      </el-form-item>
      <el-form-item label="Source ID:">
        <el-input
          style="width:240px"
          clearable
          v-model="extraData.sourceId"
          placeholder="Please typing in source ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="Source Name:">
        <el-input
          style="width:240px"
          clearable
          v-model="extraData.thirdName"
          placeholder="Please typing in source name"
        ></el-input>
      </el-form-item>
      <el-form-item label="Standard Name:">
        <select-box
          :url="STD_SEARCH_REGION"
          :queryOrderParams="{ page: 1, size: 500, deleteFlag: 1 }"
          :value.sync="extraData.standardName"
          search-key="name"
          label-key="name"
          value-key="name"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search"
          >Search</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      v-loading="loading"
      @sort-change="sort"
      :max-height="tableHeight"
    >
      <el-table-column
        label="Source of Data"
        width="140"
        align="center"
        prop="dataSource"
      >
        <template v-slot="{ row }">
          {{ originMapping[row.dataSourceCode] }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="source ID"
        width="140"
        align="center"
        prop="sourceRegionId"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        class-name="yellow-col"
        label="Standard ID"
        min-width="160"
        align="center"
        prop="standardRegionId"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        class-name="green-col"
        label="source Name"
        min-width="180"
        align="center"
        prop="thirdRegionName"
      >
        <template v-slot="{ row }">
          <div
            :class="{
              red:
                row.status &&
                compare(row.thirdRegionName, row.standardRegionName)
            }"
          >
            {{ row.thirdRegionName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="green-col"
        label="Standard Name"
        min-width="160"
        align="center"
        prop="standardRegionName"
      ></el-table-column>
      <el-table-column
        label="Status"
        align="center"
        prop="shortName"
        width="120"
      >
        <template v-slot="{ row }">
          <p :class="{ red: !row.status, green: row.status }">
            • {{ row.status ? 'Mapped' : 'UnMapped' }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Remark"
        min-width="180"
        align="center"
        prop="remark"
      >
        <template v-slot="{ row }">
          <dropdown
            :row="{
              thirdId: row.thirdRegionId,
              dataSourceCode: row.dataSourceCode,
              standardId: row.standardRegionId
            }"
            :methodStr="methodStr"
            :text="`${row.remark || 'Please select'}`"
            @get-list="getList"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Operation"
        min-width="100"
        align="center"
        prop="shortName"
      >
        <template v-slot="{ row }">
          <el-link type="primary" :underline="false" @click="edit(row)"
            >Edit</el-link
          >
        </template>
      </el-table-column>
      <el-table-column label="Langauge" min-width="160" align="center">
        <template v-slot="{ row }">
          <div>
            <i class="el-icon-document-copy langaugeDetails" @click="showLangaugeDetail(row.standardRegionId)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Log" min-width="160" align="center">
        <template v-slot="{ row }">
          <OperationType :dataType="'Third_Region'" :dataId="row.thirdRegionId" />
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" style="margin-top: 20px">
      <el-pagination
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="pageSizes"
        @current-change="changePage"
        @size-change="handleSizeChange"
        :layout="pageLayout"
      ></el-pagination>
    </el-row>
    <el-dialog
      :title="dialog.title"
      width="500px"
      :visible.sync="dialog.show"
      :close-on-click-modal="dialog.clickModal"
    >
      <el-form
        :model="dialogForm"
        :rules="rules"
        label-width="129px"
        size="mini"
        :ref="dialog.ref"
      >
        <el-form-item label="Source Name:">
          {{ dialogForm.thirdName }}
        </el-form-item>
        <el-form-item label="Standard Name:" prop="standardId" required>
          <select-box
            :url="'region/validList'"
            :queryOrderParams="{ page: 1, size: 500 }"
            :value.sync="dialogForm.standardId"
            :label="dialogForm.standardName"
            search-key="name"
            label-key="name"
            value-key="id"
          />
        </el-form-item>
        <el-form-item label="Remark:" prop="remark">
          <el-input
            v-model="dialogForm.remark"
            placeholder="Please enter remark"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="dialogSubmit"
            :loading="dialog.isLoading"
            >Confirm</el-button
          >
          <el-button @click="dialogHide">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
        <el-dialog
      :title="langDialogData.title"
      width="500px"
      :visible.sync="langDialogData.show"
      :close-on-click-modal="langDialogData.clickModal"
      :destroy-on-close="true"
    > 
            <el-form
        :model="dialogForm"
        :rules="langRules"
        label-width="120px"
        size="mini"
        :ref="dialog.ref"
      >
        <el-form-item label="ID:" v-if="langDialogData.id">
          {{ langDialogData.id }}
        </el-form-item>
        <el-form-item
          v-for="item in langData"
          :prop="`language${item}`"
          :key="item"
          :label="`${item}:`"
        >
          <el-input
            v-if="langDialogData.data"
            v-model="langDialogData.data[item]"
            placeholder="Please typing in text"
            :disabled="item === 'ENG'"
            style="width:300px"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="Remark:">
          <el-input
            v-model="langDialogData.remark"
            placeholder="Please typing in text"
            style="width:300px"
            maxlength="200"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="dialog.isLoading" @click="editLanguage(2)"
            >Confirm</el-button
          >
          <el-button @click="langDialogData.show = false">Cancel</el-button>
        </el-form-item>
      </el-form>
  </el-dialog>
  </div>
</template>

<script>
import {
  getRegionMappingList as getData,
  editRegionMapping as editData
} from '@/service/subscribe'
import { querySportRegionInternational as getLangaugeDetail } from '@/service/standard'
import TableMixin from '@/mixins/subscibe/table'
import Dropdown from '@/components/Dropdown'
import { RemarkOptions } from '@/utils/constants'
import LangMixin from '@/mixins/lang'
export default {
  name: 'RegionMapping',
  mixins: [TableMixin, LangMixin],
  components: { Dropdown },
  data() {
    return {
      RemarkOptions,
      methodStr: 'editRegionMapping',
      extraData: {
        standardName: ''
      },
      rules: {
        standardId: [
          {
            message: 'Please typing select standard name',
            required: true
          }
        ]
      }
    }
  },
  methods: {
    getLangaugeDetail,
    getData(e) {
       return getData(this.fliterParams(e,['sourceId']))
    },
    editData,
    edit(row) {
      const data = {
        thirdId: row.thirdRegionId,
        standardId: row.standardRegionId,
        standardName: row.standardRegionName,
        thirdName: row.thirdRegionName,
        sourceId: row.sourceRegionId,
        dataSourceCode: row.dataSourceCode,
        remark: row.remark
      }
      this.dialogEdit(data)
    },
    compare(a, b) {
      return (a || '').toLowerCase() !== (b || '').toLowerCase()
    }
  }
}
</script>
